import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Glyphicon, Label } from 'react-bootstrap';

class UploadQueue extends Component {
  setElementInfo = elem => {
    if (elem.error) {
      return {
        icon: 'remove',
        iconClass: 'red',
        message: () => {
          return (
            <span className="red">
              File <b>«{elem.title}»</b> wasn't uploaded successfully:{' '}
              <Label bsStyle="danger">{elem.errorMessage}</Label>
            </span>
          );
        }
      };
    }

    if (elem.pending) {
      return {
        icon: 'hourglass',
        iconClass: 'rotateMe',
        message: () => {
          return (
            <span>
              Uploading <b>«{elem.title}»</b> file.
            </span>
          );
        }
      };
    }

    return {
      icon: 'ok',
      iconClass: '',
      message: () => {
        return (
          <span>
            File <b>«{elem.title}»</b> was uploaded successfully.
          </span>
        );
      }
    };
  };

  render() {
    const { uploads } = this.props;

    if (!uploads) return null;

    const queue = _.map(uploads);

    const Queue = () => {
      return queue.map((elem, i) => {
        const elemInfo = this.setElementInfo(elem);
        return (
          <p key={i}>
            <Glyphicon
              glyph={elemInfo.icon}
              style={{ marginRight: 10 }}
              className={elemInfo.iconClass}
            />
            {elemInfo.message()}
          </p>
        );
      });
    };
    return <Queue />;
  }
}

function mapStateToProps({ uploads }) {
  return { uploads };
}

export default connect(mapStateToProps)(UploadQueue);



// WEBPACK FOOTER //
// ./src/components/UploadQueue/index.js